'use strict';

var keyboardAccessibility = require('./keyboardAccessibility');
var search = require('./search');
var desktopMenuCloseTimeouts = [];
var util = require('../util/util');
var bp = require('../util/breakpoints');

var clearSelection = function (element) {
    $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $(element).closest('li').detach();
};

const menu = {
    api: {
        initMobileAccesibilitySettings() {
            var $mainMenu = $('.main-menu');

            $mainMenu.removeAttr('aria-hidden');

            if (window.jRes.isSmall) {
                $mainMenu.attr('aria-hidden', 'true');
            }
        },
        closeMobileMenu(e) {
            e && e.preventDefault && e.preventDefault();
            if (window.jRes.isSmall || window.jRes.isXSmall) {
                $('.menu-toggleable-left').removeClass('in');
                $('.modal-background').hide();
                $('.main-menu').attr('aria-hidden', 'true');
                $('.main-menu').siblings().attr('aria-hidden', 'false');
                $('header').siblings().attr('aria-hidden', 'false');
                $('html').removeClass('bbw-overflow-hidden--from-mobile-nav');
            }
        }
    },
    init() {
        var isDesktop = function (element) {
            return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
        };

        var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
        $('.header-banner .close').on('click', function () {
            $('.header-banner').addClass('d-none');
            window.sessionStorage.setItem('hide_header_banner', '1');
        });

        if (!headerBannerStatus || headerBannerStatus < 0) {
            $('.header-banner').removeClass('d-none');
        }

        // Navigation accessibility implementation
        keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link, .main-menu .menu-items__item',
            {
                13: function (menuItem) {
                    if (menuItem.hasClass('nav-item')) { // top level
                        // Second enter on top level go to CLP
                        var activeElementHref = $(document.activeElement).attr('href');

                        if ((activeElementHref !== '') && menuItem.hasClass('nav-item--expanded')) {
                            window.location.href = activeElementHref;
                        }

                        $('.nav-item').removeClass('show nav-item--expanded');
                        menuItem.addClass('show nav-item--expanded');
                        menuItem.find('li').removeClass('menu-items__item--expanded');
                        menuItem.find('ul > li').first().addClass('menu-items__item--expanded');
                        menuItem.find('ul > li > a')
                            .first()
                            .focus();
                    } else {
                        var $expandableItems = $('.menu-items__item--expandable');
                        var $activeElement = $(document.activeElement);
                        var activeElementLink = $(document.activeElement).attr('href');

                        $expandableItems.removeClass('menu-items__item--expanded');
                        $activeElement.closest('.menu-items__item--expandable').addClass('menu-items__item--expanded');

                        if (activeElementLink.trim() !== '') {
                            window.location.href = activeElementLink;
                        }
                    }
                },
                27: function () { // escape
                    $('.nav-item--expanded').removeClass('show nav-item--expanded');
                    $('.menu-items__item--expanded').removeClass('show menu-items__item--expanded');
                    $(document.activeElement).closest('.nav-item').find('.nav-link').focus();
                }
            },
            function () {
                return $(this).parent();
            }
        );

        $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
            .on('click', function (e) {
                if (!isDesktop(this)) {
                    $('.modal-background').show();
                    // copy parent element into current UL
                    var li = $('<li class="dropdown-item top-category" role="button"></li>');
                    var link = $(this).clone().removeClass('dropdown-toggle')
                        .removeAttr('data-toggle')
                        .removeAttr('aria-expanded')
                        .attr('aria-haspopup', 'false');
                    li.append(link);
                    var closeMenu = $('<li class="nav-menu"></li>');
                    closeMenu.append($('.close-menu').first().clone());
                    $(this).parent().children('.dropdown-menu')
                        .prepend(li)
                        .prepend(closeMenu)
                        .attr('aria-hidden', 'false');
                    // copy navigation menu into view
                    $(this).parent().addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    $(link).focus();
                    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                    e.preventDefault();
                }
            })
            .on('mouseenter', function () {
                if (isDesktop(this)) {
                    var eventElement = this;
                    $('.navbar-nav > li').each(function () {
                        if (!$.contains(this, eventElement)) {
                            $(this).find('.show').each(function () {
                                clearSelection(this);
                            });
                            if ($(this).hasClass('show')) {
                                $(this).removeClass('show');
                                $(this).children('ul.dropdown-menu').removeClass('show');
                                $(this).children('.nav-link').attr('aria-expanded', 'false');
                            }
                        }
                    });
                    // need to close all the dropdowns that are not direct parent of current dropdown
                    $(this).parent().addClass('show');
                    $(this).siblings('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                }
            })
            .parent()
            .on('mouseleave', function () {
                if (isDesktop(this)) {
                    $(this).removeClass('show');
                    $(this).children('.dropdown-menu').removeClass('show');
                    $(this).children('.nav-link').attr('aria-expanded', 'false');
                }
            });
        $('.js-menu-items-expandable').on('mouseenter', function () {
            $(this).attr('aria-expanded', 'true');
        }).on('mouseleave', function () {
            $(this).attr('aria-expanded', 'false');
        });

        $('.navbar > .close-menu').on('click', menu.api.closeMobileMenu);

        $('.navbar-toggler').click(function (e) {
            e.preventDefault();
            $('.main-menu').toggleClass('in');
            $('.modal-background').show();

            $('.main-menu').removeClass('d-none');
            $('.main-menu').attr('aria-hidden', 'false');
            $('.main-menu').siblings().attr('aria-hidden', 'true');
            $('header').siblings().attr('aria-hidden', 'true');

            $('.main-menu .nav.navbar-nav .nav-link').first();
            $('html').addClass('bbw-overflow-hidden--from-mobile-nav');
        });

        keyboardAccessibility('.navbar-header .user',
            {
                40: function ($popover) { // down
                    if ($popover.children('a').first().is(':focus')) {
                        $popover.next().children().first().focus();
                    } else {
                        $popover.children('a').first().focus();
                    }
                },
                38: function ($popover) { // up
                    if ($popover.children('a').first().is(':focus')) {
                        $(this).focus();
                        $popover.removeClass('show');
                    } else {
                        $popover.children('a').first().focus();
                    }
                },
                27: function () { // escape
                    $('.navbar-header .user .popover').removeClass('show');
                    $('.user').attr('aria-expanded', 'false');
                },
                9: function () { // tab
                    $('.navbar-header .user .popover').removeClass('show');
                    $('.user').attr('aria-expanded', 'false');
                }
            },
            function () {
                var $popover = $('.user .popover li.nav-item');
                return $popover;
            }
        );

        $('.navbar-header .user').on('mouseenter focusin', function () {
            if ($('.navbar-header .user .popover').length > 0) {
                $('.navbar-header .user .popover').addClass('show');
                $('.user').attr('aria-expanded', 'true');
            }
        });

        $('.navbar-header .user').on('mouseleave', function () {
            $('.navbar-header .user .popover').removeClass('show');
            $('.user').attr('aria-expanded', 'false');
        });
        $('body').on('click', '#myaccount', function () {
            event.preventDefault();
        });

        if (!$('.navbar').length) {
            return;
        }

        // ---- BBW MOBILE event handlers ----
        $(document).on('click', '.navbar__search-cta', () => {
            menu.api.closeMobileMenu();
            search.api.openMobileSearchOverlay();
        });

        function mobileNavLinkDropdownToggle(e) {
            const $this = $(this);
            const wasExpanded = $this.closest('.nav-item').is('.nav-item--expanded');
            const $itemsWrapper = $this.parent().find('> .menu-items__wrapper');

            e.preventDefault();

            $('.nav-item--expanded').removeClass('nav-item--expanded');
            $('.menu-items__item--expanded').removeClass('menu-items__item--expanded');
            $this.closest('.nav-item').toggleClass('nav-item--expanded', !wasExpanded);
            $itemsWrapper.animate({
                height: 'toggle'
            }, 300);
            $('.menu-items__wrapper').not($itemsWrapper.get(0)).slideUp(300);
        }

        function mobileMenuItemToggle(e) {
            const $this = $(this);

            e.preventDefault();
            $this.parent().closest('.menu-items__item').toggleClass('menu-items__item--expanded');
            $this.parent().find('.menu-items__wrapper').animate({
                height: 'toggle',
                opacity: 'toggle'
            }, 300);
        }


        function closeModalOnEscapePress(event) {
            if (event.which === 27) {
                menu.api.closeMobileMenu();
            }
        }

        window.jRes.addFunc([
            {
                breakpoint: ['xsmall', 'small'],
                enter: function () {
                    $(document).on('click', '.nav-link.dropdown-toggle', mobileNavLinkDropdownToggle);
                    $(document).on('click', '.menu-items__item-cta', mobileMenuItemToggle);
                    menu.api.initMobileAccesibilitySettings();
                    $(document).on('keyup', '.bbw-main-menu-container', closeModalOnEscapePress);
                    if ($('.bbw-main-menu-container').length > 0) {
                        util.trapFocusInsideModal($('.bbw-main-menu-container')[0]);
                    }

                },
                exit: function () {
                    $(document).off('click', '.nav-link.dropdown-toggle', mobileNavLinkDropdownToggle);
                    $(document).off('click', '.menu-items__item-cta', mobileMenuItemToggle);
                    menu.api.initMobileAccesibilitySettings();
                    $(document).off('keyup', '.bbw-main-menu-container', closeModalOnEscapePress);
                }
            },
            // auto-close overlay on breakpoint change to desktop
            {
                breakpoint: ['medium', 'large', 'extraLarge', 'extraExtraLarge'],
                enter: menu.api.closeMobileMenu
            }
        ]);

        // auto-close overlay by clicking on background
        $(document).on('click', '.modal-background', () => {
            if ($('.menu-toggleable-left').is('.in')) {
                menu.api.closeMobileMenu();
            }
        });

        // "My account" menu toggling
        $(document).on('click', '.nav-item--account .nav-link', function () {
            $(this).parent().toggleClass('nav-item--expanded').find('.menu-items__wrapper').animate({
                height: 'toggle',
                opacity: 'toggle'
            }, 300);
        });

        // ---- BBW DESKTOP event handlers ----
        function desktopNavItemExpansion(e) {
            if (window.innerWidth >= bp.values.medium) {
                const $this = $(this).closest('.nav-item');

                if (util.isTouchDevice() && !$this.hasClass('nav-item--expanded') && $this.hasClass('dropdown')) {
                    e.preventDefault();
                }

                if ($this.is('.dropdown')) {
                    desktopMenuCloseTimeouts.forEach(clearTimeout);
                }
                $('.nav-item').removeClass('nav-item--expanded');
                $this.addClass('nav-item--expanded');

                if ($this.hasClass('show') && $this.find('[data-promoview-name]').length > 0) {
                    $(document).trigger('sendVisiblePromoViewFromViewport');
                }
            }
        }

        function desktopNavItemCollapse() {
            const $this = $(this);
            const timeout = setTimeout(() => {
                const $firstItem = $this.find('> .menu-items__wrapper > .menu-items > .menu-items__item:eq(0)');
                const $thirdLvlMenu = $firstItem.find('.menu-items__wrapper');

                $this.removeClass('nav-item--expanded');
                if ($this.is('.dropdown')) {
                    $this.find('.menu-items__item--expanded').removeClass('menu-items__item--expanded');
                    $firstItem.addClass('menu-items__item--expanded');

                    if ($thirdLvlMenu.length) {
                        $this.find('> .menu-items__wrapper').css('min-height', $thirdLvlMenu.outerHeight() + 40 + 'px');
                        $this.find('.menu-items__category-slot-wrapper').css('transform', `translateX(${$thirdLvlMenu.outerWidth() + 30}px)`);
                    }
                }
            }, 1000);

            desktopMenuCloseTimeouts.push(timeout);
        }

        function desktopMenuItemExpansion() {
            const $this = $(this);
            const $thirdLvlMenu = $this.find('.menu-items__wrapper');

            $this.parent().find('.menu-items__item').removeClass('menu-items__item--expanded');
            $this.addClass('menu-items__item--expanded');

            if ($thirdLvlMenu.length) {
                $this.closest('.menu-items__wrapper').css('min-height', $thirdLvlMenu.outerHeight() + 40 + 'px');
                $this.closest('.nav-item').find('.menu-items__category-slot-wrapper').css('transform', `translateX(${$thirdLvlMenu.outerWidth() + 30}px)`);
            }
        }

        function desktopExpandedNavSticky() {
            const $navbar = $('.navbar');

            if ($navbar.length === 0 && !$navbar.get(0)) {
                return;
            }

            const navbarRect = $navbar.get(0).getBoundingClientRect();
            const navbarViewportBottom = navbarRect.top + navbarRect.height;

            if (navbarViewportBottom < -20) {
                $('.nav-item > .menu-items__wrapper').css('transform', `translateY(${-navbarViewportBottom}px)`);
            } else {
                $('.nav-item > .menu-items__wrapper').css('transform', 'translateY(0)');
            }
        }

        window.jRes.addFunc([
            {
                breakpoint: ['medium', 'large', 'extraLarge', 'extraExtraLarge'],
                enter: function () {
                    var eventListOnEnter = 'mouseenter';

                    if (util.isTouchDevice()) {
                        eventListOnEnter = 'click';
                    }

                    $(document).on(eventListOnEnter, '.nav-item .nav-link', desktopNavItemExpansion);
                    $(document).on('mouseleave', '.nav-item .nav-link', desktopNavItemCollapse);
                    $(document).on('mouseenter', '.nav-item > .menu-items__wrapper > .menu-items > .menu-items__item', desktopMenuItemExpansion);
                    $(window).on('scroll', desktopExpandedNavSticky);
                    $(document).on('click.outsideNavigation', function (e) {
                        var $target = $(e.target);
                        var $menuWrapper = $target.closest('.main-menu');

                        if (!$menuWrapper.length) {
                            $(document).find('.nav-item--expanded').removeClass('nav-item--expanded');
                        }
                    });

                    // Close the menu if hover outside
                    $(document).on('mouseleave.outsideNavigation', '.main-menu', function () {
                        var $mainMenu = $(this);
                        if ($mainMenu.length > 0) {
                            $(document).find('.nav-item--expanded').removeClass('nav-item--expanded');
                        }
                    });

                    // initially pre-select first items in second lvl menus
                    $('.nav-item > .menu-items__wrapper > .menu-items').each(function () {
                        const $this = $(this);
                        const $thirdLvlMenu = $this.find('.menu-items__wrapper');
                        const $firstItem = $this.find('.menu-items__item:eq(0)');

                        $firstItem.addClass('menu-items__item--expanded');
                        $this.closest('.menu-items__wrapper').css('min-height', $thirdLvlMenu.outerHeight() + 40 + 'px');
                        $this.closest('.nav-item').find('.menu-items__category-slot-wrapper').css('transform', `translateX(${$thirdLvlMenu.outerWidth() + 30}px)`);
                    });
                },
                exit: function () {
                    var eventListOnExit = 'mouseenter';

                    if (util.isTouchDevice()) {
                        eventListOnExit = 'click';
                    }

                    $(document).off(eventListOnExit, '.nav-item.dropdown .nav-link', desktopNavItemExpansion);
                    $(document).off('mouseleave', '.nav-item.dropdown .nav-link', desktopNavItemCollapse);
                    $(document).off('mouseenter', '.nav-item > .menu-items__wrapper > .menu-items > .menu-items__item', desktopMenuItemExpansion);
                    $(window).off('scroll', desktopExpandedNavSticky);
                    $(document).off('click.outsideNavigation');
                    $(document).off('mouseleave.outsideNavigation');

                    $('.nav-item > .menu-items__wrapper > .menu-items').each(function () {
                        const $this = $(this);
                        const $firstItem = $this.find('.menu-items__item:eq(0)');

                        $firstItem.addClass('menu-items__item--expanded');
                        $this.closest('.menu-items__wrapper').css('min-height', 0);
                        $this.closest('.nav-item').find('.menu-items__category-slot-wrapper').css('transform', 'translateX(0)');
                    });

                    $('.menu-items__item--expanded').removeClass('menu-items__item--expanded');
                }
            }
        ]);
    }
};

module.exports = menu;
